// import store from '@/store';
// import { USER_USERINFO_UPDATE } from '@/store/mutationTypes';
import { getBaseInfoApi } from '@/api/burialPoint';
import { queryParse } from 'cfmoto-utils';
import postToken from '@/utils/postToken';
import store from '@/store';
import { USER_USERINFO_CLEAR, USER_USERINFO_UPDATE } from '@/store/mutationTypes';
export { onViewportResize, removeViewportResize, emitViewportResize, onBlur, removeBlur, emitBlur, onFocus, removeFocus, emitFocus } from './events';

export const userInfoPromise = async () => {
  return getBaseInfoApi({}, { to: { meta: { auth: 0 } } });
};

export const userInfoCommitPromise = async () => {
  try {
    // token处理
    const query = queryParse(window.location.href.split('#')[0]);

    const isInject = await window.zeeho.awaitInject();
    const nativeToken = isInject ? await postToken() : query.token || '';
    query.token = nativeToken || query.token || '';
    query.token = query.token.replace(/[bB]earer/, '').trim();
    const localToken = JSON.parse(localStorage.getItem('token') || '""')
      .replace(/[bB]earer/, '')
      .trim();
    // if(!window.zeeho.isNativeEnv ||!query.token){

    // }
    if (query.token && query.token !== localToken) {
      localStorage.setItem('token', JSON.stringify(decodeURIComponent(query.token || '')));
    }
    await new Promise((resolve) => setTimeout(resolve, 0));
    const resData = await userInfoPromise({});
    const userInfo = resData.data || {};
    localStorage.setItem('user_id', JSON.stringify(decodeURIComponent(userInfo.id || '')));
    store.commit(USER_USERINFO_UPDATE, userInfo);
    return userInfo;
  } catch (error) {
    localStorage.setItem('user_id', JSON.stringify(''));
    store.commit(USER_USERINFO_CLEAR, {});
    return {};
  }
};

export const userInfoCommitComposable = userInfoCommitPromise();
